import { getFeatureToggle } from 'utils/feature-toggle/index';

export const featNetcrackerLive = (): boolean =>
  getFeatureToggle({
    name: 'feat-netcracker-live',
    enabledByDefault: true,
    allowedInProduction: true,
  });
